
import { defineComponent } from 'vue'
import { getCardImage } from '~/utils/billing'

export default defineComponent({
  name: 'V2DeleteCardModal',
  props: {
    brand: {
      type: String,
      required: true
    },
    brandLabel: {
      type: String,
      required: true
    },
    lastFour: {
      type: String,
      required: true
    },
    expiryLabel: {
      type: String,
      required: true
    },
    processing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardImage(): string {
      return getCardImage(this.brand)
    }
  },
  methods: {
    close(): void {
      if (this.processing) return
      this.$emit('close')
    }
  }
})
